$(document).ready(function () {
    var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
    );

    let headerContainer = $(".page-header"),
        body = $("body"),
        isEditing = body.hasClass("website-state-edit");

    $(".main-navigation-sub").append(
        "<div class='main-navigation-sub-arrow'></div>"
    );

    if (isMobile) {
        $(".main-navigation-sub-arrow").click(() => {
            if ($(".main-navigation-sub").hasClass("open")) {
                $(".main-navigation-sub").removeClass("open");
            } else {
                $(".main-navigation-sub").addClass("open");
            }
        });
    }

    $("[data-search-box-toggle]").click(() => {
        $("[data-search-box-open]").slideToggle(200);
        $("[data-search-box-toggle]").toggleClass("open");
        $("[data-search-box-open-input]").focus();
    });

    if ($("body").hasClass("page-type-search-page") && !isMobile) {
        $("[data-search-box-open]").slideToggle(0);
        $("[data-search-box-toggle]").toggleClass("open");
    }

    if (navigator.userAgent.indexOf("Edge") !== -1 && !isMobile) {
        $("[data-search-box-open-input]").removeAttr("placeholder"); // Removes the placeholder attribute when on Edge and not mobile, this is done to right align the input cursor, which is otherwise not possible in Edge with a placeholder active.
    }

    $(".menu-toggle").click(() => {
        $("body").toggleClass("open-menu");
    });

    if (!isEditing) {
        //FIXED HEADER CHANGE ON SCROLL
        var lastScrollTop = 0;
        const limitScrollTop = 175;
        $(window).scroll(() => {
            if ($("body").hasClass("page-type-landing-page"))
            {
                if ($(window).scrollTop() >= 20) {
                    $("body").addClass("fixed-header");
                }
                else {
                    $("body").removeClass("fixed-header");
                }
            }
            else
            {
                var st = $(this).scrollTop();
                if (st < lastScrollTop) {
                    $(headerContainer).removeClass("page-header-minimal");
                } else if (st > lastScrollTop && st > limitScrollTop) {
                    $(headerContainer).addClass("page-header-minimal");
                }
                lastScrollTop = st;
            }
        });
    }
});
